export enum StatusColors {
  'Enabled' = '#66EA6D',
  'Out Of Care' = '#EDD766',
  'In Hospital' = '#ED9A37',
  'Disabled' = '#C6C6C6',
  'Archived' = '#989898',
}

export type StatusType = keyof typeof StatusColors;
